(function(){
    'use strict';

    angular.module('dataHandlingActionAddWaitTime', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble'])
        .controller('actionAddWaitTimeCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionAddWaitTimeCtrl]);

    function actionAddWaitTimeCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayAddWaitTimeActionOptions = false;
        $scope.errorUnits = false;
        $scope.errorDelay = false;
        $scope.descriptionEmpty = false;

        // accepted values
        $scope.enums = {
            minutes: 60,
            hours: 24,
            days: 365,
            weeks: 52,
            months: 12
        };

        $scope.setUnits = (delay) => {
            let period = (delay > 1) ? 'plural' : 'singular';

            $scope.units = {
                hours: $scope.translate(`canvas.action.addWaitTime.hours.${period}`),
                days: $scope.translate(`canvas.action.addWaitTime.days.${period}`),
                weeks: $scope.translate(`canvas.action.addWaitTime.weeks.${period}`),
                months: $scope.translate(`canvas.action.addWaitTime.months.${period}`)
            };
        };

        let delay = 0;
        if($scope.connections) {
            delay = $scope.connections.data.delay;
        }
        $scope.setUnits(delay);

        $rootScope.$on('displayActionAddWaitTimeModal', function(evt, conn, showTip) {
            $scope.contactListData = $rootScope.contactListData;
            $scope.showTip = showTip;
            $scope.displayAddWaitTimeActionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.errorUnits = false;
            $scope.errorDelay = false;
            $scope.descriptionEmpty = false;
        });

        $rootScope.$on('hideActionAddWaitTimeModal', function() {
            $scope.errorUnits = false;
            $scope.errorDelay = false;
            $scope.displayAddWaitTimeActionOptions = false;
        });

        $rootScope.$on('displayActionAddWaitTimeModalError', function(evt, unitsErr, delayErr) {
            $scope.errorUnits = unitsErr;
            $scope.errorDelay = delayErr;
        });

        $scope.cancel = function() {
            $scope.displayAddWaitTimeActionOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            // Execute listener when user cancel the add the node of delay
            if (!node) {
                $rootScope.$broadcast('deleteWaitTimeNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            Intercom('trackEvent', 'AP - Delay');
            $rootScope.$emit('saveActionAddWaitTimeData' + $scope.connections.id, $scope.connections);
        };

        $scope.$watch('connections.data.delay', (val) => {
            if(val) {
                $scope.setUnits(val);
            }
        });

        $scope.$watch('connections.data.units', function(val){
            if(val) {
                if($scope.connections.data.delay > $scope.enums[val]){
                    $scope.connections.data.delay = '';
                }
            }
        });
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/actionAddWaitTimeController.js